module.exports = __webpack_public_path__ + "static/media/801Hou@4x.570a15f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/801Hou@4x.png
// module id = 1691
// module chunks = 0 1